import {Icon, Typography} from '@bonprix/design-system';
import React from 'react';

export const ProductSuggestions = ({products, searchTerm, allArticlesLabel, onViewAll, onProductClick}) => {
    if (!products || products.length === 0) {
        return null;
    }

    return (
        <div className="search__product-suggestions !mt-[22px] xl:!mt-0">
            <button
                className="search__all-articles-link px-4 xl:px-0"
                onClick={onViewAll}
                onMouseDown={(e) => e.preventDefault()}
            >
                <Typography variant="body1" component="span">
                    {renderAllArticlesLabel(allArticlesLabel, searchTerm)}
                </Typography>
                <Icon variant="arrow-right" className="search__all-articles-arrow" />
            </button>
            <ul className="search__product-suggestions-list" role="list">
                {products.map((product) => (
                    <li key={product.id} className="search__product-suggestion">
                        <a
                            className="search__product-suggestion-link"
                            href={product.link}
                            onMouseDown={(e) => e.preventDefault()}
                            onClick={() => onProductClick?.(product)}
                        >
                            {product.imageUrl && (
                                <img
                                    className="search__product-suggestion-image"
                                    src={product.imageUrl}
                                    alt=""
                                    loading="lazy"
                                />
                            )}
                            <div className="mx-3">
                                <Typography
                                    variant="body1"
                                    component="span"
                                    className="search__product-suggestion-name"
                                >
                                    {product.name}
                                </Typography>
                            </div>
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
};

const renderAllArticlesLabel = (label, searchTerm) => {
    const term = <strong key="term">&quot;{searchTerm}&quot;</strong>;
    const template = label || 'Alle Artikel für {term} ansehen';
    const [prefix, suffix = ''] = template.split('{term}');
    return (
        <>
            {prefix}
            {term}
            {suffix}
        </>
    );
};
